class SupportFaqTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = [...this.querySelectorAll('[data-faq-tab]')];
    this.panels = [...this.querySelectorAll('[data-faq-panel]')];
    this.tabs.forEach((tab) => tab.addEventListener('click', this.handleTabClick));
  }

  disconnectedCallback() {
    this.tabs?.forEach((tab) => tab.removeEventListener('click', this.handleTabClick));
  }

  handleTabClick = (event) => {
    const selectedKey = event.currentTarget.dataset.faqTab;

    this.tabs.forEach((tab) => {
      const isSelected = tab.dataset.faqTab === selectedKey;
      tab.classList.toggle('is-active', isSelected);
      tab.setAttribute('aria-expanded', String(isSelected));
    });

    this.panels.forEach((panel) => {
      const isSelected = panel.dataset.faqPanel === selectedKey;
      panel.hidden = !isSelected;
      if (!isSelected) panel.querySelectorAll('details[open]').forEach((details) => details.removeAttribute('open'));
    });
  };
}

if (!customElements.get('support-faq-tabs')) {
  customElements.define('support-faq-tabs', SupportFaqTabs);
}
